export default __webpack_public_path__ + "static/media/img9.4102bfd6.png";